
import React from 'react';
import { Suspense, lazy } from 'react';
import { MainAppMethods } from '../../App';

const Component = lazy(() => import("./GraphOne"));
const UnsentNotificationsGraph = lazy(() => import("./UnsentNotificationsGraph"));

function NotificationGraphsContainer(props: MainAppMethods) {
     
    return (
        <Suspense fallback={<div>loading...</div>}>
                <Component getHeaders={props.getHeaders} onClose={props.onClose} />
                <UnsentNotificationsGraph getHeaders={props.getHeaders} onClose={props.onClose} />
            </Suspense>
      );

}

export default NotificationGraphsContainer; 
